// action
import {
    DELETE_CONTAINER,
    DELETE_CONTAINER_FAIL,
    DELETE_CONTAINER_SUCCESS,
    DELETE_CONTAINER_RESET
} from '../action/deleteContainerAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_CONTAINER:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_CONTAINER_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_CONTAINER_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_CONTAINER_RESET:
            return initialState
        default:
            return state
    }
}